var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6387 9.39244C11.9711 10.0611 11.3368 10.6962 10.6692 11.3648C10.6692 9.86047 10.6692 8.32266 10.6692 6.81828C10.6692 6.51741 10.6692 6.24996 10.6692 5.94909C10.6692 5.11332 9.36731 5.11332 9.36731 5.94909C9.36731 7.75434 9.36731 9.55959 9.36731 11.3648C8.69968 10.6962 8.06543 10.0611 7.3978 9.39244C6.79693 8.79069 5.89563 9.72675 6.4965 10.2951C7.53132 11.3314 8.53277 12.3343 9.5676 13.3707C9.80127 13.6047 10.2019 13.6047 10.4355 13.3707C11.4704 12.3343 12.4718 11.3314 13.5066 10.2951C14.1409 9.72675 13.2396 8.82412 12.6387 9.39244Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.814 8.05678C18.9127 3.40992 14.7067 0 9.99985 0C5.79377 0.0668612 1.98827 2.70788 0.552859 6.71955C-0.849168 10.6644 0.486095 15.2109 3.75749 17.8185C6.99551 20.4261 11.6689 20.727 15.2408 18.554C18.7792 16.381 20.6152 12.1353 19.814 8.05678ZM15.7081 16.5816C12.9708 18.9886 8.89826 19.3897 5.76039 17.6179C2.58914 15.8127 0.78653 12.1353 1.42078 8.5248C2.18856 4.34598 5.82715 1.37065 9.99985 1.30379C13.5717 1.30379 16.9098 3.57707 18.145 6.95357C19.4135 10.3301 18.4454 14.208 15.7081 16.5816Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.20ccaa9363ecf02cab5c8814e9c77137.svg";
export { ForwardRef as ReactComponent };